module.exports = __webpack_public_path__ + "img/shouhuodizhi.079c83c2.svg";